import { mapState } from 'vuex'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'
import { WebApi } from '@/services/WebApi'

export const ClientUserCheckingMixin = {
  mixins: [SelectedSiteIdMixin],
  data () {
    return {
      fetchingClient: false,
      error: ''
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'clientTypeId'
    ]),
    ...mapState('Client', [
      'client'
    ]),
    cachedClientId () {
      return this.client?.id || ''
    }
  },
  watch: {
    selectedSiteId () {
      this.fetchClient()
    }
  },
  methods: {
    fetchClient () {
      const self = this
      if (!self.selectedSiteId || self.clientTypeId !== 1) return
      self.error = ''
      self.fetchingClient = true
      WebApi.get('Portal/' + self.selectedSiteId + '/Client')
        .then(({ data }) => {
          if (data?.id && data.id !== self.cachedClientId) {
            window.location.reload()
          }
        })
        .finally(() => { self.fetchingClient = false })
    }
  },
  created () {
    this.fetchClient()
  }
}
